module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOSAzOSI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2JhNGQ1MDt9LmJ7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48Y2lyY2xlIGNsYXNzPSJhIiBjeD0iMTkuNSIgY3k9IjE5LjUiIHI9IjE5LjUiLz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMyAxMikiPjxyZWN0IGNsYXNzPSJiIiB3aWR0aD0iNCIgaGVpZ2h0PSIxNSIgcng9IjIiLz48cmVjdCBjbGFzcz0iYiIgd2lkdGg9IjQiIGhlaWdodD0iMTUiIHJ4PSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMCkiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/images/audio/detailstop.svg
// module id = eFoX
// module chunks = 1